var map = {
	"./template.bet575": 1482,
	"./template.bet575.tsx": 1482,
	"./template.bet777": 1483,
	"./template.bet777.tsx": 1483,
	"./template.betgalaxy": 1484,
	"./template.betgalaxy.tsx": 1484,
	"./template.betprofessor": 1485,
	"./template.betprofessor.tsx": 1485,
	"./template.betroyale": 1486,
	"./template.betroyale.tsx": 1486,
	"./template.betstride": 1487,
	"./template.betstride.tsx": 1487,
	"./template.buffalobet": 1488,
	"./template.buffalobet.tsx": 1488,
	"./template.chromabet": 1489,
	"./template.chromabet.tsx": 1489,
	"./template.default": 665,
	"./template.default.tsx": 665,
	"./template.epicodds": 1490,
	"./template.epicodds.tsx": 1490,
	"./template.fiestabet": 1491,
	"./template.fiestabet.tsx": 1491,
	"./template.forsport": 1492,
	"./template.forsport.tsx": 1492,
	"./template.gigabet": 1493,
	"./template.gigabet.tsx": 1493,
	"./template.goldenbet888": 1494,
	"./template.goldenbet888.tsx": 1494,
	"./template.goldenrush": 1495,
	"./template.goldenrush.tsx": 1495,
	"./template.hyperbet": 1496,
	"./template.hyperbet.tsx": 1496,
	"./template.juicybet": 1497,
	"./template.juicybet.tsx": 1497,
	"./template.junglebet": 1498,
	"./template.junglebet.tsx": 1498,
	"./template.magnumbet": 1499,
	"./template.magnumbet.tsx": 1499,
	"./template.oldgill": 1500,
	"./template.oldgill.tsx": 1500,
	"./template.puntcity": 1501,
	"./template.puntcity.tsx": 1501,
	"./template.puntgenie": 1502,
	"./template.puntgenie.tsx": 1502,
	"./template.pyramidbet": 1503,
	"./template.pyramidbet.tsx": 1503,
	"./template.questbet": 1504,
	"./template.questbet.tsx": 1504,
	"./template.slambet": 1505,
	"./template.slambet.tsx": 1505,
	"./template.sterlingparker": 1506,
	"./template.sterlingparker.tsx": 1506,
	"./template.sugarcastle": 1507,
	"./template.sugarcastle.tsx": 1507,
	"./template.templebet": 1508,
	"./template.templebet.tsx": 1508,
	"./template.titanbet": 1509,
	"./template.titanbet.tsx": 1509,
	"./template.ts": 979,
	"./template.vikingbet": 1510,
	"./template.vikingbet.tsx": 1510,
	"./template.volcanobet": 1511,
	"./template.volcanobet.tsx": 1511,
	"./template.wellbet": 1512,
	"./template.wellbet.tsx": 1512
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2441;